module.exports = __webpack_public_path__ + "static/img/remittance-add-more-icon.9c524618.svg";